import { TDevice } from '@cian/utils';

import { IAppState } from '../../../AppModulesWrapper';

export const selectLayoutDeviceType = (state: IAppState): TDevice => {
  return state.servicePickerWidget.layout.adaptiveSettings.deviceType;
};
